type StoreStatuses = 'NOT STARTED' | 'PENDING' | 'VERIFY' | 'COMPLETED'
type StoreStatusKeys = 'N' | 'P' | 'V' | 'C'

const StoreStatusesLockedKeys: [string, string] = ['P', 'C']
const StoreStatusesLocked: [string, string] = ['P', 'C']

type StoreData = {
  essUserOnBoardingKey?: number
  hireDate?: string | null
  pendingStartDate?: string | null
  brandingName?: string | null
  storeName?: string | null
  storeShortName?: string | null
  storeAddress1?: string | null
  storeAddress2?: string | null
  storeAddress3?: string | null
  storePhoneNumber?: string | null
  storeNumber?: string | null
  department?: string | null
  employeeRole?: string | null
  perPayTypeDescription?: string | null
  perPayCycleDescription?: string | null
  perScheduleDescription?: string | null
  rate?: number | null
  perPayByDescription?: string | null
  storeStatusValue?: string | null
  statusDescription?: string | null
  storeAdress1: string | null
  storeAdress2: string | null
  storeCity: string | null
  storeState: string | null
  storeZipCode: string | null
  scheduledHours: number
}

type StoreUpdateData = {
  submitted: boolean
  message: string
}

export {
  StoreStatuses,
  StoreStatusesLockedKeys,
  StoreStatusesLocked,
  StoreData,
  StoreUpdateData,
  StoreStatusKeys
}
